import { Cookie, X } from 'lucide-react'
import { useEffect, useState } from 'react'

const COOKIE_CONSENT_KEY = 'cookie_consent'

export function CookieBanner() {
    const [isVisible, setIsVisible] = useState(false)

    useEffect(() => {
        // Check if consent was already given
        const consent = localStorage.getItem(COOKIE_CONSENT_KEY)
        if (!consent) {
            // Show banner after a small delay
            const timer = setTimeout(() => setIsVisible(true), 2000)
            return () => clearTimeout(timer)
        }
    }, [])

    const handleAccept = () => {
        localStorage.setItem(COOKIE_CONSENT_KEY, 'accepted')
        setIsVisible(false)
    }

    const handleDecline = () => {
        localStorage.setItem(COOKIE_CONSENT_KEY, 'declined')
        setIsVisible(false)
    }

    if (!isVisible) return null

    return (
        <div className="fixed bottom-4 left-4 right-4 sm:left-auto sm:right-4 sm:max-w-sm z-50 animate-in slide-in-from-bottom duration-500">
            <div className="bg-white/95 dark:bg-slate-900/95 backdrop-blur-xl rounded-2xl border border-slate-200 dark:border-slate-700 p-4 shadow-2xl">
                <div className="flex items-start gap-3">
                    <div className="p-2 bg-indigo-50 dark:bg-indigo-900/30 rounded-lg shrink-0">
                        <Cookie size={18} className="text-indigo-600 dark:text-indigo-400" />
                    </div>
                    <div className="flex-1">
                        <div className="flex items-center justify-between mb-2">
                            <h4 className="font-bold text-slate-800 dark:text-slate-200 text-sm">Cookie Notice</h4>
                            <button
                                onClick={handleDecline}
                                className="p-1 hover:bg-slate-100 dark:hover:bg-slate-800 rounded-lg transition-colors"
                            >
                                <X size={14} className="text-slate-400 dark:text-slate-500" />
                            </button>
                        </div>
                        <p className="text-xs text-slate-500 dark:text-slate-400 mb-3">
                            We use cookies to store your preferences and improve your experience.
                        </p>
                        <div className="flex gap-2">
                            <button
                                onClick={handleAccept}
                                className="flex-1 px-3 py-1.5 bg-indigo-500 hover:bg-indigo-600 text-white rounded-lg text-xs font-bold transition-colors shadow-md shadow-indigo-500/20"
                            >
                                Accept
                            </button>
                            <button
                                onClick={handleDecline}
                                className="flex-1 px-3 py-1.5 bg-slate-100 dark:bg-slate-800 hover:bg-slate-200 dark:hover:bg-slate-700 text-slate-700 dark:text-slate-300 rounded-lg text-xs font-bold transition-colors"
                            >
                                Decline
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}
